import { render } from "./OrderConfirmationPage.vue?vue&type=template&id=e09b4528"
import script from "./OrderConfirmationPage.vue?vue&type=script&lang=js"
export * from "./OrderConfirmationPage.vue?vue&type=script&lang=js"

import "./OrderConfirmationPage.vue?vue&type=style&index=0&id=e09b4528&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__